import memoize                   from 'lodash-es/memoize';
import { TooltipParams }         from '@/components/chart/chart.types';
import { useGlobals }            from '@/hooks/use-globals';
import { chartTooltipStorePath } from '@/components/chart/chart-tooltip/helpers/chart-tooltip.helpers';

import Format = echarts.EChartOption.Tooltip.Format;

export const useXAxisTooltipContent = memoize((content: Format | Format[]): string => {
  const { store } = useGlobals();
  const params = content as TooltipParams[];

  store.commit(`${chartTooltipStorePath}/setNewParams`, params);

  return '';
});
